module.exports = __webpack_public_path__ + "media/assets/services_manager/logos/pamoja-c533b160cc30990aab70b5b76fe776daf263705fb74cd5b6851be93cbb09e905.png";